import {useState, useEffect} from "react";

import {
    FormGroup,
    Label,
    Input,
    Button
  } from "reactstrap";

function FormTable({addInfo}) {

  const [year2, setYear2] = useState(0)
  const [fName, setFName] = useState('')
  const [lName, setLName] = useState('')
  const [email, setEmail] = useState('')
  const [age, setAge] = useState(0)
  const [category, setCategory] = useState('')
  const [isVege, setIsVege] = useState(false)
  const [allergies, setAllergies] = useState('')


  const calcPrice = () => {
    if (category.includes('INSA') || category.includes('Diplômé')) return 42
    if (category.includes('UPHF')) return 45
    if (category.includes('Exté')) return 50
}

  const onSubmit = (e) => {
    e.preventDefault()
    addInfo({firstName: fName, lastName: lName, email: email, year: year2, category: category, price: calcPrice(), age: age, isVege: isVege, allergies: allergies})
}

  return (
    <div id="form-table">
          <form onSubmit={onSubmit}>
            <FormGroup className={fName.length > 1 ? "has-success" : "has-danger"}>
                <Input className={fName.length > 1 ? "form-control-success" : "form-control-danger"} placeholder="Prénom" type="text" value={fName} onChange={(e) => setFName(e.target.value)} required></Input>
            </FormGroup>
            <FormGroup className={lName.length > 1 ? "has-success" : "has-danger"}>
                <Input className={lName.length > 1 ? "form-control-success" : "form-control-danger"} placeholder="Nom" type="text" value={lName} onChange={(e) => setLName(e.target.value)} required></Input>
            </FormGroup>
            <FormGroup className={(email.length > 1 && email.includes("@")) ? "has-success" : "has-danger"}>
                <Input className={(lName.length > 1 && email.includes("@")) ? "form-control-success" : "form-control-danger"} placeholder="Email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} required></Input>
            </FormGroup>
            <FormGroup>
                <label>Régime :</label>
                <Input type="select" onChange={(e) => setCategory(e.target.value)}>
                    <option value=''></option>
                    <option value="INSA">Etudiant INSA</option>
                    <option value="Diplômé">Diplômé</option>
                    <option value="UPHF">UPHF</option>
                    <option value="Exté">Extérieur</option>
                </Input>
            </FormGroup>
            {(category.includes("INSA") || category.includes("Diplômé")) && <FormGroup>
                <label>Année :</label>
                <Input type="select" onChange={(e) => setYear2(e.target.value)}>
                    <option value={0}></option>
                    <option value={1}>1A</option>
                    <option value={2}>2A</option>
                    <option value={3}>3A</option>
                    <option value={4}>4A</option>
                    <option value={5}>5A</option>
                    <option value={6}>6A</option>
                    <option value={7}>7A</option>
                    <option value={8}>8A</option>
                </Input>
            </FormGroup>}
            {((year2 < 3) && (category.includes("INSA"))) && 
            <FormGroup className={(age > 0) ? "has-success" : "has-danger"}>
                <label>Age (pour les 1As et 2As) :</label>
                <Input className={(age > 0) ? "form-control-success" : "form-control-danger"} placeholder="0" type="number" value={age} onChange={(e) => setAge(e.target.value)} required></Input>
            </FormGroup>}
            <p></p>
            <FormGroup check>
                <Label check>
                <Input defaultValue="" type="checkbox" checked={isVege} value={isVege} onChange={(e) => setIsVege(e.currentTarget.checked)}></Input>
                Option végétarienne
                <span className="form-check-sign">
                    <span className="check"></span>
                </span>
                </Label>
            </FormGroup>
            <br></br>
            <FormGroup>
                <label>
                    Allergies :
                </label>
                <Input
                    id="textarea1"
                    rows="3"
                    type="textarea"
                    placeholder="Aucune ?"
                    value={allergies}  
                    onChange={(e) => setAllergies(e.target.value)}
                ></Input>
            </FormGroup>
            <div className="text-center">
                <Button type='submit' value='Enregistrement'>Enregistrer cette personne</Button>
            </div>
        </form>
    </div>
  );
}

export default FormTable;
